
<div class="stepper-next-prev d-flex align-items-center" :class="[buttonLayout, { 'stepper-next-prev--sticky': sticky }]">
    <button class="btn btn-outline-primary" @click="prevStep" :disabled="!enablePrevButton">{{
        currentStep === 1 ? 'Cancel' : prevButtonLabel }}</button>
    <button class="btn btn-primary" @click="nextStep" :disabled="disableNextButton">{{ nextButtonLabel }}</button>
</div>
